document.addEventListener('DOMContentLoaded', function () {
  var STORAGE_KEY = 'snrkickz_recently_viewed_articles';
  var MAX_ITEMS = 8;

  /* ---------- Track current article view ---------- */
  var tracker = document.querySelector('[data-article-recently-viewed-track]');
  if (tracker) {
    try {
      var entry = {
        title: tracker.getAttribute('data-article-title'),
        url: tracker.getAttribute('data-article-url'),
        image: tracker.getAttribute('data-article-image')
      };
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      stored = stored.filter(function (item) { return item.url !== entry.url; });
      stored.unshift(entry);
      stored = stored.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (e) {
      /* localStorage unavailable — skip silently */
    }
  }

  /* ---------- Render recently viewed list (excludes current article) ---------- */
  var listEl = document.querySelector('[data-recently-viewed-list]');
  var sectionEl = document.querySelector('[data-recently-viewed-section]');
  if (listEl && sectionEl) {
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      var currentUrl = tracker ? tracker.getAttribute('data-article-url') : null;
      items = items.filter(function (item) { return item.url !== currentUrl; });
      if (items.length) {
        items.forEach(function (item) {
          var card = document.createElement('a');
          card.href = item.url;
          card.className = 'article-recently-viewed__card';
          card.innerHTML =
            (item.image ? '<div class="article-recently-viewed__media"><img src="' + item.image + '" loading="lazy" alt="' + (item.title || '') + '"></div>' : '') +
            '<span class="article-recently-viewed__title">' + (item.title || '') + '</span>';
          listEl.appendChild(card);
        });
        sectionEl.hidden = false;
      }
    } catch (e) {
      /* skip silently */
    }
  }

  /* ---------- Mobile sticky product CTA ---------- */
  var ctaCard = document.querySelector('[data-article-product-cta]');
  if (ctaCard && window.matchMedia('(max-width: 749px)').matches) {
    var stickyBar = document.createElement('div');
    stickyBar.className = 'article-sticky-cta';
    var titleEl = ctaCard.querySelector('.article-product-cta__title');
    var priceEl = ctaCard.querySelector('.article-product-cta__price');
    var linkHref = titleEl ? titleEl.getAttribute('href') : '#';
    stickyBar.innerHTML =
      '<div class="article-sticky-cta__info">' +
        '<span class="article-sticky-cta__title">' + (titleEl ? titleEl.textContent : '') + '</span>' +
        '<span class="article-sticky-cta__price">' + (priceEl ? priceEl.textContent : '') + '</span>' +
      '</div>' +
      '<a href="' + linkHref + '" class="btn btn-primary article-sticky-cta__btn">Bekijk product</a>';
    document.body.appendChild(stickyBar);

    var shown = false;
    var onScroll = function () {
      var rect = ctaCard.getBoundingClientRect();
      var pastCard = rect.bottom < 0;
      if (pastCard && !shown) {
        stickyBar.classList.add('is-visible');
        shown = true;
      } else if (!pastCard && shown) {
        stickyBar.classList.remove('is-visible');
        shown = false;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Inline product cards ----------
     Content writers paste this one line anywhere in the article body:
     <div class="snr-inline-product" data-product-handle="product-handle-here"></div>
     This fetches the product via Shopify's AJAX API and renders a single
     clickable card: image, "Vanaf €X", title, and size count. The card
     is then relocated (see below) — desktop into the sidebar rail,
     mobile into a stack after the full article text.
  ------------------------------------------------------------------------- */
  var inlineProductNodes = document.querySelectorAll('.snr-inline-product[data-product-handle]');
  inlineProductNodes.forEach(function (el) {
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;
    el.classList.add('is-loading');
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product) {
          el.remove();
          return;
        }
        var img = product.featured_image || (product.images && product.images[0]) || '';
        if (img && img.indexOf('http') !== 0) {
          img = 'https:' + img;
        }
        var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        var priceFormatted;
        try {
          priceFormatted = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: currency }).format(product.price / 100);
        } catch (e) {
          priceFormatted = '€' + (product.price / 100).toFixed(2);
        }
        var url = product.url || ('/products/' + product.handle);
        var safeTitle = (product.title || '').replace(/"/g, '&quot;');
        var sizeCount = (product.variants && product.variants.length) || 0;
        var sizeLabel = sizeCount === 1 ? '1 maat beschikbaar' : sizeCount + ' maten beschikbaar';

        var card = document.createElement('a');
        card.href = url;
        card.className = 'snr-inline-product__card';
        card.innerHTML =
          (img ? '<div class="snr-inline-product__media"><img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" loading="lazy" alt="' + safeTitle + '"></div>' : '') +
          '<div class="snr-inline-product__body">' +
            '<div class="snr-inline-product__price-row"><span class="snr-inline-product__label">Vanaf</span> <span class="snr-inline-product__price">' + priceFormatted + '</span></div>' +
            '<span class="snr-inline-product__title">' + product.title + '</span>' +
            (sizeCount ? '<span class="snr-inline-product__meta">' + sizeLabel + '</span>' : '') +
          '</div>';

        el.innerHTML = '';
        el.appendChild(card);
        el.classList.remove('is-loading');
        el.classList.add('is-loaded');
      })
      .catch(function () {
        el.remove();
      });
  });

  /* ---------- Relocate inline product cards ----------
     Desktop (>=1000px): move every .snr-inline-product out of the running
     text into the sticky sidebar rail next to the article.
     Mobile (<1000px): move every .snr-inline-product into a stack placed
     after the full article text, instead of leaving them inline mid-copy.
  ------------------------------------------------------------------------- */
  var isDesktop = window.matchMedia('(min-width: 1000px)').matches;
  var desktopRail = document.querySelector('[data-product-rail]');
  var mobileRail = document.querySelector('[data-product-rail-mobile]');
  var target = isDesktop ? desktopRail : mobileRail;
  if (target) {
    document.querySelectorAll('.article__inner .snr-inline-product, .article__inner .snr-inline-product-row').forEach(function (wrapper) {
      if (wrapper.classList.contains('snr-inline-product-row')) {
        // Unwrap rows on relocation — each card becomes its own rail item
        var cards = Array.prototype.slice.call(wrapper.querySelectorAll('.snr-inline-product'));
        cards.forEach(function (card) { target.appendChild(card); });
        wrapper.remove();
      } else if (wrapper.parentElement && !wrapper.parentElement.classList.contains('snr-inline-product-row')) {
        target.appendChild(wrapper);
      }
    });
  }
});
